import React, { useState } from 'react';
import { HashLink, NavHashLink } from 'react-router-hash-link';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import {
  Box,
  Button,
  FormGroup,
  Stack,
  TextField
} from '@mui/material';
import Title from './Title';
import Paragraph from './Paragraph';
import { fetchPlace } from './fetchPlace';
import './styles.css';

// Initialize Firebase
firebase.initializeApp({
    apiKey: "AIzaSyA1LQEcE58AkN9OeK28JxYucVYtLGAWrZc",
    authDomain: "jackson-egress-windows.firebaseapp.com",
    databaseURL: "https://jackson-egress-windows-default-rtdb.firebaseio.com",
    projectId: "jackson-egress-windows",
    storageBucket: "jackson-egress-windows.appspot.com",
    messagingSenderId: "280363051462",
    appId: "1:280363051462:web:a75a629cd2512c116d6ac7"
});

const firestore = firebase.firestore();

const Details = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');  
  const [zipcode, setZipcode] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [city, setCity] = useState("");
  const [autocompleteCities, setAutocompleteCities] = useState([]);
  const [autocompleteErr, setAutocompleteErr] = useState("");
  const handleCityChange = async (e) => {
     setCity(e.target.value);
if (!city) return;

const res = await fetchPlace(city);
!autocompleteCities.includes(e.target.value) &&
res.features &&
setAutocompleteCities(res.features.map((place) => place.place_name));
res.error ? setAutocompleteErr(res.error) : setAutocompleteErr("");
};

  const handleSubmit = (event) => {
    event.preventDefault();

    // Save form data to Firestore
    firestore.collection('leads').add({
      name,
      phone,
      email,
      address,
      city,
      zipcode,
      message
    })
      .then(() => {
        console.log('Form data saved successfully!');
        // Reset form fields
        setName('');
        setPhone('');
        setEmail('');
        setAddress('');       
        setZipcode('');
        setMessage('');
        
        
       
  setSubmitted(true);


      })
      .catch((error) => {
        console.error('Error saving form data: ', error);
      });
  };

  return (
    <Stack
      component='section'
      direction="column"
      justifyContent='center'
      alignItems='center'
      paddingBottom='100px'
      paddingTop='10px'
      
      sx={{
        py: '100px',
        px: 2,
      }}
      id='quote-form'
    >


      <Title
        text={'Let Us Bring Your Basement To Life!'}
        textAlign={'center'}
        padding={'40px'}
      />
      <Paragraph
        text={'Fill out the details below.'}
        maxWidth={'800px'}
       
        textAlign={'center'}
        sx={{
          maxWidth: '800px',
          width: '90%'
        }}
      />
      <Paragraph
        text={'We will contact you within 24 hours.'}
        maxWidth={'800px'}
        width={'90%'}
        textAlign={'center'}
        sx={{
          maxWidth: '800px',
          width: '90%'
        }}
      />


      {submitted ? (
        <Box textAlign="center" mt={4}>
          <Paragraph
            text={'Thank you! We will be in touch soon!'}
            textAlign={'center'}
            maxWidth={'800px'}
            width={'90%'}
            sx={{
              maxWidth: '800px',
              width: '90vw'
            }}
          />
        </Box>
      ) : (
        <Box
          component="form"
          noValidate
          width="90vw"
          maxWidth="600px"
          onSubmit={handleSubmit}
          sx={{
            mt: 1,
            py: 2
          }}
        >
          
          <FormGroup>
            <TextField
              margin="normal"
              required
              fullWidth
              id="name"
              label="Your Name"
              name="name"
              autoComplete="name"
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="phone"
              label="Phone Number"
              type="phone"
              id="phone"
              autoComplete="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <br />
            <TextField
              margin="normal"
              required
              fullWidth
              name="email"
              label="Your Email"
              type="email"
              id="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <br />
            <TextField
              margin="normal"
              required
              fullWidth
              name="address"
              label="Street Address"
              type="address"
              id="address"
              autoComplete="address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />

            <br />

            <div className="placesAutocomplete">
        <div className="placesAutocomplete__inputWrap">
          <label htmlFor="city" className="label">
            Your city
            {autocompleteErr && (
              <span className="inputError">{autocompleteErr}</span>
            )}
            </label>
            <input
            className="custom-autocomplete-input"
            list="places"
            type="text"
            id="city"
            name="city"
            onChange={handleCityChange}
            value={city}
            required
            pattern={autocompleteCities.join("|")}
            autoComplete="off"
          />
          <datalist id="places">
            {autocompleteCities.map((city, i) => (
              <option key={i}>{city}</option>
            ))}
          </datalist>
          <span className="placesAutocomplete__hint">
            *start typing and choose your city from the given options
          </span>

            <br />
            <TextField
             margin="normal"
             fullWidth
             name="zipcode"
             label="Zip Code"
             type="text" // Change the type to "text"
             id="zipcode"
             autoComplete="postal-code" // Change the autoComplete to "postal-code"
             inputMode="numeric" // Add the inputMode prop
             value={zipcode}
             onChange={(e) => setZipcode(e.target.value)}
            />

<br />
            <TextField
             margin="normal"
             fullWidth
             height="100px"
             name="message"
             label="Message"
             type="text" // Change the type to "text"
             id="message"
             autoComplete="I would like to ask..." 
             inputMode="text"
             defaultValue="Let us know about your project..." // Add the inputMode prop
             value={message}
             multiline
             onChange={(e) => setMessage(e.target.value)}
            />
            </div>
</div>
          </FormGroup>

          <br />
          {!submitted && (
            <Button
              variant="contained"
              fullWidth
              type="submit"
              size="large"
              sx={{
                fontSize: '1.2rem',
                textTransform: 'capitalize',
                height: '60px',
                py: 2,
                mt: 3,
                mb: 2,
                borderRadius: 1.3,
                backgroundColor: 'rgb(14, 173, 25)',
                borderColor: '#4dc548',
                "&&:hover": {
                  color: 'rgb(0, 0, 0)',
                  backgroundColor: 'rgb(19, 204, 31)',
              },
              "&&:focus": {
                  color: '#0deb2a',
                  borderColor: '#000000',
              }
              }}
            >
              Submit
            </Button>
          )}
        </Box>
      )}
    </Stack>
  );
};

export default Details;


